import { fetchVersionInfo } from '../../../services/Content';
import Logger from '../../../utils/logger';
import store from '../../markettingContentGeneration';
import {
  featureFlagsStateSegment,
  convertFeatureInfoToFeatures,
} from '../stateSegments/featureFlagsStateSegment';

/**
 * Fetches feature flags from the version info API and updates the state
 * This should be called during application boot time
 */
export const initializeFeatureFlags = async (): Promise<boolean> => {
  try {
    // Set loading state
    store.set(featureFlagsStateSegment, prev => ({
      ...prev,
      isLoading: true,
      error: null,
    }));

    // Fetch version info which contains feature flags
    const versionData = await fetchVersionInfo();

    if (versionData?.applicationConfig?.featureInfo) {
      const features = convertFeatureInfoToFeatures(
        versionData.applicationConfig.featureInfo
      );

      // Update state with loaded features
      store.set(featureFlagsStateSegment, prev => ({
        ...prev,
        isLoading: false,
        isLoaded: true,
        features,
        error: null,
      }));

      return true;
    } else {
      throw new Error('No feature info found in version response');
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';

    Logger.error(
      new Error(`Failed to initialize feature flags: ${errorMessage}`)
    );

    // Set error state
    store.set(featureFlagsStateSegment, prev => ({
      ...prev,
      isLoading: false,
      isLoaded: false,
      error: errorMessage,
    }));

    return false;
  }
};

/**
 * Refreshes feature flags (useful for manual refresh or retry scenarios)
 */
export const refreshFeatureFlags = async (): Promise<boolean> => {
  return initializeFeatureFlags();
};
